import { render, staticRenderFns } from "./WolfRow.vue?vue&type=template&id=5855b268&scoped=true&"
import script from "./WolfRow.vue?vue&type=script&lang=js&"
export * from "./WolfRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5855b268",
  null
  
)

export default component.exports